export default __webpack_public_path__ + "static/HL-F_Euro_4c-72b1123e848f8d9a9d2cddad106901ab.svg";